"use client"

import Title from "@/components/common/Typography/Title"
import { Button, Col, Row } from "antd"
import { useTranslation } from "react-i18next"
import HotelGoodPricesDesktop from "./index.desktop"
import HotelGoodPricesMobile from "./index.mobile"
import dayjs from "dayjs"

const HotelGoodPricesCRS = ({ data }: { data: any[] }) => {
  const { t, i18n } = useTranslation()
  const commonLocation = [
    { name: "Hồ Chí Minh", id: "13170", type: "CITY" },
    { name: "Vũng Tàu", id: "17190", type: "CITY" },
    { name: "Đà Lạt", id: "15932", type: "CITY" },
    { name: "Phan Thiết", id: "16264", type: "CITY" },
    { name: "Quy Nhơn", id: "17242", type: "CITY" },
    { name: "Phú Quốc", id: "17188", type: "CITY" },
    { name: "Đà Nẵng", id: "16440", type: "CITY" },
    { name: "Nha Trang", id: "2679", type: "CITY" },
  ]

  return (
    <Row style={{ marginBottom: "3rem", width: "100%" }}>
      <Col span={24} style={{ marginBottom: "1rem" }}>
        <Title level={3} style={{ margin: 0, marginBottom: "0.5rem" }}>
          {t("hotel.goodprices_title")}
        </Title>
      </Col>
      <Col span={24} className="hotels__goodprices-locations">
        <Row gutter={[8, 8]} wrap={false}>
          {commonLocation.map(({ name, id, type }) => (
            <Col key={id} flex="none">
              <Button
                type="primary"
                ghost
                shape="round"
                size="small"
                onClick={() => {
                  const checkIn = dayjs().add(dayjs().endOf("month").get("date"), "day")
                  const checkOut = checkIn.add(1, "day")
                  window.open(
                    `/${i18n.language}/hotels/result?adt=2&child=0&room=1&in=${checkIn.format("YYYY-MM-DD")}&out=${checkOut.format("YYYY-MM-DD")}&loc=${id}&type=${type}`,
                    "_blank",
                  )
                }}
              >
                {name}
              </Button>
            </Col>
          ))}
        </Row>
      </Col>
      <Col span={24}>
        <HotelGoodPricesDesktop data={data} />
        <HotelGoodPricesMobile data={data} />
      </Col>
    </Row>
  )
}

export default HotelGoodPricesCRS
